import { render, staticRenderFns } from "./WallSpeakersBlock.vue?vue&type=template&id=0b7e3401"
import script from "./WallSpeakersBlock.vue?vue&type=script&lang=js"
export * from "./WallSpeakersBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports